import {Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import {SlownikService} from '../../../../../../../shared/services/slownik/slownik.service';
import {NavigationService} from '../../../../../../../shared/services/navigation/navigation.service';
import {
  UszkodzeniaWLokalizacjiComponent
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';
import {
  FormularzUszkodzenService
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {LokalizacjaUszkodzenia} from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {
  BaseLokalizacjaUszkodzenZParametryPrzedmiotyComponent
} from '../base-lokalizacja-uszkodzen-z-parametry-przedmioty.component';
import {
  ParametryUszkodzen,
  ParametryZbioruUszkodzen
} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';

@Component({
  selector: 'app-dach',
  templateUrl: './dach.component.html'
})
export class DachComponent extends BaseLokalizacjaUszkodzenZParametryPrzedmiotyComponent implements OnInit, OnDestroy {

  @ViewChildren(UszkodzeniaWLokalizacjiComponent) uszkodzenia!: QueryList<UszkodzeniaWLokalizacjiComponent>;

  constructor(route: ActivatedRoute, store: Store, navigation: NavigationService,
              formularzUszkodzenService: FormularzUszkodzenService,
              slownikService: SlownikService) {
    super(route, store, navigation, formularzUszkodzenService, slownikService);
  }

  get slownikUszkodzen(): SlownikUszkodzen[] {
    return [SlownikUszkodzen.POKRYCIE_DACHU, SlownikUszkodzen.GASIORY, SlownikUszkodzen.OBROBKI_BLACHARSKIE, SlownikUszkodzen.PODBITKA_DACHOWA,
      SlownikUszkodzen.KOMIN, SlownikUszkodzen.BARIERY_PRZECIWSNIEGOWE, SlownikUszkodzen.WYLAZ_DACHOWY];
  }

  get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.DACH;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  zapiszUszkodzeniazPodformularzy(): void {
    const parametry = {} as ParametryZbioruUszkodzen;
    if (this.czyDataRemontuWymagana) {
      parametry.dataRemontu = this.formularzLokalizacjiUszkodzenia.controls.dataRemontu.value;
    }
    const uszkodzenia = this.uszkodzenia
      .filter((element) => (element.wszystkieWartosciWypelnione() || element.formularzUszkodzenia.valid) && element.czyUszkodzenieWybraneNaFormularzu())
      .map((element) => {
        const parametryUszkodzenia = {} as ParametryUszkodzen
        return element.utworzObiektUszkodzenia(parametryUszkodzenia)
      });
    this.utworzLubAktualizujZbiorUszkodzen(parametry, uszkodzenia);
    this.zapiszLiczbePieter(this.formularzLokalizacjiUszkodzenia.controls.liczbaPieter.value);
  }
}
